import styled from "styled-components";

const SummaryContainer = styled.div`
  border-radius: 8px;
  background-color: white;
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const RootContainer = styled.div`
  background-color: rgb(245, 245, 245);
  min-height: 100vh;
`;

const HeaderContainer = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

const HeaderCloseButtonContainer = styled.div`
  position: absolute;
  left: 10px;
  :hover {
    cursor: pointer;
  }
`;

const HeaderTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
`;

const ProductsContainer = styled.div``;

const SendOrderButton = styled.button`
  border: 1px solid black;
  background: black;
  color: white;
  outline: none;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
`;

const PayButton = styled.button`
  border: 1px solid #39bc5e;
  background: #39bc5e;
  color: white;
  outline: none;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
`;
const SendOrderToSellerButton = styled.button`
  border: 1px solid #39bc5e;
  background: #39bc5e;
  color: white;
  outline: none;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
`;

const CancelOrderButton = styled.button`
  border: 1px solid #d00e0e;
  background: #ebd8d8;
  color: #d00e0e;
  outline: none;
  width: 100%;
  font-size: 16px;
  border-radius: 8px;
`;

const ContactCompanyButton = styled.button`
  border: 1px solid #2546bb;
  background: white;
  color: #2546bb;
  outline: none;
  width: 100%;
  font-size: 16px;
  border-radius: 8px;
`;

const modules = {
  HeaderTitle,
  HeaderContainer,
  HeaderCloseButtonContainer,
  RootContainer,
  SummaryContainer,
  ProductsContainer,
  SendOrderButton,
  CancelOrderButton,
  PayButton,
  ContactCompanyButton,
  SendOrderToSellerButton,
};

export default modules;
